import React from "react";
import { UploadFileIcon } from "../../Icons";

const UploadFileBtn = ({
  handleClick = null,
  label = "Upload File",
  variant = "",
  className = "",
  disabled = false,
}) => {
  const defaultBtnClasses =
    "flex items-center justify-center gap-2 border border-[#DEDEDE] bg-[#FAFAFA] px-[20px] py-[5px] rounded-[5px] text-[#252525] font-medium text-[0.7rem]";
  const lessonGeneratorClasses =
    "flex items-center gap-2 w-full h-[45px] rounded-[6px] border border-[#ECECEC] bg-[#FFFFFF] px-[15px] text-[#252525] font-medium text-[13px] shadow-[0px_4px_5px_0px_rgba(0,0,0,0.05)] justify-start";

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  const buttonClasses = `${variant === "lessonGenerator" ? lessonGeneratorClasses : defaultBtnClasses} ${disabledClasses} ${className}`.trim();

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={buttonClasses}
    >
      <UploadFileIcon />
      <span>{label}</span>
    </button>
  );
};

export default UploadFileBtn;
